var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception"},[_c('div',{staticClass:"imgBlock"},[_c('div',{staticClass:"imgEle",style:({backgroundImage: `url(${_vm.config[_vm.type].img})`})})]),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.config[_vm.type].title))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.config[_vm.type].desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }